<!--
    描述：编辑模板
    日期：2022/07/01
    作者：张卫华
-->
<template>
  <div class="edit-template-form-page">
    <iframe :src="templateUrl" style="height: 100%;width: 100%"></iframe>
  </div>
</template>
<script>
import * as API  from 'api/modules/es/es_template.js'
import {docTemplateEditUrl} from "../../../../api/modules/es/es_template";
export default {
  name : '',
  components: {
  },
  props:{
    docTemplateId:{
      type : String,
      default : ''
    }
  },
  data() {
    return {
      templateUrl : '',
    }
  },
  mounted() {},
  computed: {},
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {
    this.getDocTemplateEditUrl()
  },
  methods: {
    getDocTemplateEditUrl(){
      let param = {
        docTemplateId : this.docTemplateId
      }
      API.docTemplateEditUrl(param).then(res=>{
        if(res.code == 0 && res.data) {
          this.templateUrl = res.data
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.edit-template-form-page {
  height : 100%;
}
</style>